import React from "react";

export default function GapCard({ bg, icon, title, children }) {
  return (
    <div
      className={`flex h-full flex-col rounded-[32px] sm:rounded-[36px] lg:rounded-[40px] p-6 sm:p-8 lg:p-10 xl:p-12 shadow-sm ${bg}`}
    >
      <div className="flex justify-center mb-6 sm:mb-8">{icon}</div>

      <h3 className="text-xl sm:text-2xl md:text-[26px] lg:text-[32px] font-semibold sm:font-bold text-ekatraBlue mb-3 sm:mb-4">
        {title}
      </h3>

      <p className="text-base md:text-lg text-[#1b3a4b] leading-relaxed">
        {children}
      </p>
    </div>
  );
}
